import {gsap} from "gsap";
import {DasUBoot} from "../../DasUBoot";
import {DasUBootGameAssets} from "../../DasUBootGameAssets";

/**
 * Created by jonas on 2021-06-03.
 */

export class FreespinReTriggerView extends PIXI.Container{
    private ring:PIXI.Sprite;
    private animation:gsap.core.Timeline;
    private plus:PIXI.Sprite;

    constructor() {
        super();

        this.ring = new PIXI.Sprite(DasUBoot.assetLoader.getTextures(DasUBootGameAssets.SHARP_RING)[0]);
        this.ring.anchor.set(0.5,0.5);
        this.ring.tint = 0x00ff00;
        this.ring.alpha = 0;
        this.addChild(this.ring);

        this.plus = new PIXI.Sprite(DasUBoot.assetLoader.getTextures(DasUBootGameAssets.PLUS2)[0]);
        this.plus.anchor.set(0.5,0.5);
        this.plus.alpha = 0;
        this.addChild(this.plus);

        this.animation = this.createAttention();

    }

    private createAttention():gsap.core.Timeline {
        const tl:gsap.core.Timeline = gsap.timeline({paused:true});


        const shrink = gsap.timeline();
        shrink.add(gsap.fromTo(this.ring, {alpha:0}, {duration:0.2, alpha:1}));
        shrink.add(gsap.fromTo(this.ring.scale, {x:0.5,y:0.5}, {duration:1, x:0,y:0}), "<");
        shrink.add(gsap.to(this.ring, {duration:0.2, alpha:0}), "-=0.2");
        shrink.duration(0.5);


        const number = gsap.timeline();
        number.add(gsap.fromTo(this.plus, {alpha:0}, {duration:0.2, alpha:1}));
        number.add(gsap.fromTo(this.plus.position, {x:0,y:0}, {duration:1, x:0,y:-100}), "<");
        number.add(gsap.to(this.plus, {duration:0.2, alpha:0}), "-=0.2");


        const grow = gsap.timeline();
        grow.add(gsap.fromTo(this.ring, {alpha:0}, {duration:0.2, alpha:1}));
        grow.add(gsap.fromTo(this.ring.scale, {x:0,y:0}, {duration:1, x:1,y:1}), "<");
        grow.add(gsap.to(this.ring, {duration:0.5, alpha:0}), "-=0.5");
        grow.duration(1);

        tl.addLabel("start");
        tl.add(shrink);

        tl.addLabel("grow");
        tl.add([
            number,
            grow
        ])
        tl.addLabel("end");


        return tl;
    }

    public getAttention():gsap.core.Tween {
        return this.animation.tweenFromTo("start", "grow");
    }

    public getEnding() {
        return this.animation.tweenFromTo("grow", "end");
    }
}